// TeamSection.jsx
import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import '../../../../assets/css/customer/subscreens/about/TeamSection.css';
import seharImg from '../../../../assets/images/sehar.jpeg';
import aminaImg from '../../../../assets/images/amina.jpeg';
import NayabImg from '../../../../assets/images/nayab2.jpeg';


const TeamSection = () => {
  const team = [
    {
      id: 1,
      name: 'Nayab Qaiser',
      role: 'Super Admin',
       image: NayabImg ,
      // description:
      //   'Oversees the CraftHive platform end-to-end approving new sellers and making sure the marketplace runs smoothly for everyone.'
    },
    {
      id: 2,
      name: 'Sehar Rehman',
      role: 'Super Admin',
      image: seharImg ,
      // description:
      //   'Handles seller support and platform complaints, helping artisans get their shops set up and sorted quickly.'
    },
    {
      id: 3,
      name: 'Amina Ijaz',
      role: 'Super Admin',
       image: aminaImg,
      // description:
      //   'Reviews every listing on CraftHive, making sure only quality, genuinely handmade products make it to the marketplace.'
    }
  ];

  return (
    <section className="team-section">
      <Container>
        <h2 className="section-title-center">Meet Our Team</h2>
        {/* <p className="section-subtitle-center">
          Passionate people dedicated to supporting artisans
        </p> */}

        <Row className="team-grid">
          {team.map((member) => (
            <Col lg={4} md={6} sm={12} key={member.id}>
              <div className="team-card">
                <div className="team-image-wrapper">
                  <img src={member.image} alt={member.name} className="team-image" />
                </div>
                <div className="team-info">
                  <h3 className="team-name">{member.name}</h3>
                  <p className="team-role">{member.role}</p>
                  <p className="team-description">{member.description}</p>
                </div>
              </div>
            </Col>
          ))}
        </Row>
      </Container>
    </section>
  );
};

export default TeamSection;